<template>
  <div class="profile">
    <div class="profile-wrapper">
      <div class="profile-content">
        <div class="profile-data">
          <div class="profile-name">{{ profile.name }}</div>
          <div class="profile-positions">{{ positions }}</div>
        </div>
        <div class="profile-stats">
          <div class="profile-stats__item"><span class="label">Вкладки/поля</span></div>
          <div class="profile-stats__item">
            <span class="label">сотр.</span>
            <span class="value">{{ profile.stats.employee.tabs }}/{{ profile.stats.employee.fields }},</span>
          </div>
          <div class="profile-stats__item">
            <span class="label">канд.</span>
            <span class="value">{{ profile.stats.candidate.tabs }}/{{ profile.stats.candidate.fields }},</span>
          </div>
          <div class="profile-stats__item">
            <span class="label">кр. канд.</span>
            <span class="value">{{ profile.stats.shortCandidate.tabs }}/{{ profile.stats.shortCandidate.fields }}</span>
          </div>
        </div>
      </div>
      <div class="profile-actions">
        <c-button
          v-b-popover.hover.blur.top="'Редактировать'"
          class="profile-edit"
          size="iconic"
          icon="edit"
          @click="$router.push({ name: 'edit-profile', params: { id: profile.id } })"
        />
        <c-button
          v-b-popover.hover.blur.top="'Удалить'"
          class="profile-remove"
          size="iconic"
          :icon="{ icon: 'trash', color: 'secondary' }"
          @click="$emit('remove')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";

export default {
  components: { CButton },
  props: ["profile"],
  computed: {
    positionsList() {
      return this.$store.state.positions.positionsList;
    },
    positions() {
      const list = this.positionsList;

      return this.profile.positions
        .map((positionCode) => {
          const position = list.find((p) => p.value === positionCode);
          return position ? position.label : false;
        })
        .filter(Boolean)
        .join(", ");
    },
  },
  methods: {
    getPositionName(code) {
      const position = this.positions.find((p) => p.value === code);
      return position ? position.label : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.profile {
  padding: 10px 15px;
  border-bottom: 1px solid #dfe4ef;

  &:first-child {
    border-top: 1px solid #dfe4ef;
  }
  &-wrapper {
    display: flex;
    align-items: center;
  }
  &-content {
    flex-grow: 1;
    line-height: 1.4;
    margin-right: 15px;
  }
  &-data {
    margin-bottom: 6px;
  }
  &-name {
    font-size: 13px;
  }
  &-positions {
    font-size: 11px;
    color: $label;
  }
  &-stats {
    font-size: 11px;
    display: flex;
    flex-wrap: wrap;
    &__item {
      margin-right: 4px;
      white-space: nowrap;
    }
    .label {
      color: $label;
    }
    .value {
      color: black;
      font-weight: 500;
      margin-left: 4px;
    }
  }
  &-actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
  &-edit {
    margin-right: 10px;
  }
  &-remove {
    transform: translateY(-2px);
  }

  @include bootstrapLg {
    &-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-data {
      margin-bottom: 0;
      margin-right: 15px;
    }
    &-stats {
      flex-wrap: nowrap;
      flex-shrink: 0;
    }
  }
}
</style>
